import { useEffect, useState } from 'react'

import { NAME_MAX_SIZE, formFields } from './constants'

import type { ExternalLinkFormFields } from '../externalLinkModal'

type FieldState = {
  maxSize: number
  currentSize: number
  isTouched: boolean
}
type UseFieldStateProps = Record<string, FieldState>

export const useFieldState = (data: ExternalLinkFormFields) => {
  const [fieldsState, setFieldsState] = useState<UseFieldStateProps>({} as UseFieldStateProps)

  useEffect(() => {
    setFieldsState((current) => ({
      [formFields.name.name]: {
        maxSize: NAME_MAX_SIZE,
        currentSize: data.name.value?.length ?? 0,
        isTouched: current[formFields.url.name]?.isTouched ?? false
      },
      [formFields.url.name]: {
        maxSize: Infinity,
        currentSize: data.url.value?.length ?? 0,
        isTouched: current[formFields.url.name]?.isTouched ?? false
      }
    }))
  }, [data.name.value.length, data.url.value.length])

  return { fieldsState, setFieldsState }
}
